function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent } from "vue";
import { downloadModel } from "@pt/api/gmaker/project.js";
import { downloadWithIframe } from "@/common/download";
export default defineComponent({
    props: {
        category: {
            type: Object,
            required: true
        },
        resource: {
            type: Object,
            default: function() {
                return null;
            }
        },
        buttonAttrs: {
            type: Object
        }
    },
    setup: function setup(props) {
        function download() {
            return _download.apply(this, arguments);
        }
        function _download() {
            _download = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return downloadModel({
                                id: props.resource.id,
                                skeleton_type: props.resource.extra.skeleton_type
                            });
                        case 2:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                // @ts-ignore
                                downloadWithIframe(res.data.data.url, "", true);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _download.apply(this, arguments);
        }
        return {
            download: download
        };
    }
});
